// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AF0P","left":"styles_left__2wCXp"};